import React, { FunctionComponent } from 'react'

import { Address } from '../../../../domain'
import { Input } from '../../types'
import { AddressFinder } from './AddressFinder'

export const AddressFormInput: FunctionComponent<Input<Address>> = ({
  value,
  onChange,
  tKey,
  tName,
  t,
}) => {
  return (
    <AddressFinder
      initialValue={value}
      onSelect={onChange}
      t={t}
      tName={tName}
      tKey={tKey}
    />
  )
}
